import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { ZendeskGroupContent } from 'src/app/interfaces/zendesk-group-content';

import { BaseModel } from './base-model';

export class ZendeskGroup extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ZendeskGroupProperties: (
    | {
        property: keyof ZendeskGroup;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ZendeskGroup;
        type: 'alias';
      }
    | {
        property: keyof ZendeskGroup;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ZendeskGroupId', type: 'column', dataType: 'number' },
    { property: 'groupContentJSON', type: 'column', dataType: 'JSON' },
    { property: 'isDeleted', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    ZendeskGroup.ZendeskGroupProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ZendeskGroup.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ZendeskGroup.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ZendeskGroup.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ZendeskGroupObject: Partial<ZendeskGroup>) {
    super();

    ZendeskGroup.ZendeskGroupProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ZendeskGroupObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  ZendeskGroupId?: string;
  groupContentJSON?: ZendeskGroupContent;
  isDeleted?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}
